// extracted by mini-css-extract-plugin
module.exports = {"name":"styles_name__240r2"};